module.exports = __webpack_public_path__ + "img/literacy_eles_banner.light.aef77d60.png";